export function getAmendmentText(sectionNumber: string | undefined | null, t: (key: string, options?: Record<string, unknown>) => string): string {
  if (!sectionNumber) {
    return t("cards.amendmentPrefix.clause", { section_number: "—" });
  }
  switch (sectionNumber) {
    case "1.1":
      return t("cards.amendmentPrefix.position");
    case "4.1":
      return t("cards.amendmentPrefix.workSchedule");
    case "4.12":
      return t("cards.amendmentPrefix.salary");
    default:
      return t("cards.amendmentPrefix.clause", { section_number: sectionNumber });
  }
}

